import React, { Component } from 'react'
import { Translate, I18n } from "react-redux-i18n";
import { validate } from "validate.js";
import validators from './validators';
import LoadingIndicator from "../../components/LoadingIndicator";
import { connect } from "react-redux";
import { isFetchingCircles } from "../../store/my_circles/selectors";
import { sendCircleRequest } from "../../store/my_circles/operations";

import {
    Button,
    Card,
    Elevation,
    Dialog,
    InputGroup,
    TextArea,
  } from "@blueprintjs/core";
  
  import CustomIcon from "../../components/CustomIcon";

class RequestCircle extends Component {
    state = {
        isOpen: false,
        validation_errors: {},
        request_form: {           
            email: "",           
            description: ""            
        }
    };  

    updateFields=(event)=>{       
        this.setState({
            request_form:{
                ...this.state.request_form,
                [event.target.id]: event.target.value
            }
        });
    }
    
    submitForm=(e)=>{
        e.preventDefault();     

        const validationErrors = validate(this.state.request_form, validators);
        
        this.setState({
          validation_errors: validationErrors ? validationErrors : {}
        });     
         
        if (!validationErrors) {
            this.props.sendCircleRequest({
                email: this.state.request_form.email,
                message: this.state.request_form.description
            }).then(()=>{
                this.handleClose();
            });
        }
    }
        
    handleOpen = () => {
        this.setState({ isOpen: true })
    };
    handleClose = () => {
        this.setState({
            isOpen: false,
            validation_errors: {},
            request_form: {           
                email: "",           
                description: ""            
            }
        })
    };   

  render() {
    return (
      <>
        <Card
            onClick={this.handleOpen}
            interactive={true}
            elevation={Elevation.ONE}
            className="cta-hero-card half-grid flex-col-center"
        >
            <CustomIcon
                name="megaphone-outline"
                className="icon secondary-color"
                size="48"
            />
            <h1>
                <Translate value="home.request_circle.heading" />
            </h1>
            <p>
                <Translate value="home.request_circle.sub_heading" />
            </p>
            <Button
                intent="primary"
                className="cta secondary-color"
                fill={true}>
                <Translate value="home.request_circle.button" />
            </Button>
        </Card>
        <Dialog
            onClose={this.handleClose}
            title={I18n.t("general_messages.find_match")}
            autoFocus={true}
            canEscapeKeyClose={true}
            canOutsideClickClose={true}
            enforceFocus={true}
            isOpen={this.state.isOpen}
            usePortal={true}>
            <div className="dialog-wrapper">
            <form onSubmit={this.submitForm}>
            <div className={
                this.state.validation_errors.email
                ? "form-group error"
                : "form-group"
            }>                    
                <label htmlFor="email">
                    {this.state.validation_errors.email?
                        <Translate
                            value={this.state.validation_errors.email[0]}
                        />
                    :
                        <Translate
                            value={"user_details.labels.email"}
                        />
                    }                                 
                </label>
                    <InputGroup
                        type="email"
                        value = {this.state.request_form.email}
                        placeholder={I18n.t("user_details.placeholders.email")}
                        fill={true}
                        id="email"
                        intent={this.state.validation_errors.email ? "danger" : ""}
                        className="no-icon"
                        onChange={this.updateFields}
                    />
                </div>

                <div className={
                    this.state.validation_errors.description
                    ? "form-group error"
                    : "form-group"
                }>
                    <label htmlFor="description">
                        {this.state.validation_errors.description?
                            <Translate
                                value={this.state.validation_errors.description[0]}
                            />
                        :
                            <Translate
                                value={"errors.request_circle.description"}
                            />
                        }                                 
                    </label>                         
                    <TextArea
                        placeholder={I18n.t("request_circle.placeholders.description")}
                        value = {this.state.request_form.description}
                        fill={true}
                        id="description"
                        onChange={this.updateFields}
                    />
                </div>

                {this.props.isLoading && <LoadingIndicator />}
                {!this.props.isLoading && 
                    <Button intent="primary" type="submit" fill={true} onClick={this.submitForm}>
                        <Translate
                            value={"general_messages.send_request"}
                        />
                    </Button>
                }
            </form>
            </div>
        </Dialog>
      </>
    )
  }
}
const mapStateToProps = (state, ownProps) => ({   
    isLoading: isFetchingCircles(state)     
  });
  const mapDispatchToProps = dispatch => ({   
    sendCircleRequest: payload=>{return dispatch(sendCircleRequest(payload))} 
  });
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(RequestCircle);